import TopicPage from '../components/TopicPage';

const sections = [
  {
    title: 'OpenShift Fundamentals',
    icon: '🏁',
    cards: [
      {
        icon: '🔴',
        title: 'What is OpenShift',
        level: 'beginner',
        description: 'Red Hat OpenShift is an enterprise Kubernetes distribution with built-in security, CI/CD, and developer tooling.',
        topics: ['OKD vs RHOCP', 'Control plane', 'etcd', 'API server'],
      },
      {
        icon: '💻',
        title: 'OC CLI',
        level: 'beginner',
        description: 'The oc command-line tool extends kubectl with OpenShift-specific commands for managing projects and resources.',
        topics: ['oc login', 'oc new-project', 'oc status', 'oc explain'],
      },
      {
        icon: '📁',
        title: 'Projects & Namespaces',
        level: 'beginner',
        description: 'OpenShift Projects wrap Kubernetes namespaces with additional RBAC and network isolation defaults.',
        topics: ['Project templates', 'ResourceQuota', 'NetworkPolicy', 'SCC defaults'],
      },
    ],
  },
  {
    title: 'Builds & Deployments',
    icon: '🏗️',
    cards: [
      {
        icon: '🔨',
        title: 'BuildConfigs',
        level: 'intermediate',
        description: 'OpenShift-native build system. Source-to-Image (S2I), Dockerfile, and custom build strategies.',
        topics: ['S2I', 'Dockerfile build', 'Build triggers', 'ImageStreams'],
      },
      {
        icon: '🖼️',
        title: 'ImageStreams',
        level: 'intermediate',
        description: 'Abstractions for container images that track changes and trigger automated deployments.',
        topics: ['Tags', 'Import policy', 'Triggers', 'Internal registry'],
      },
      {
        icon: '🚀',
        title: 'DeploymentConfigs',
        level: 'intermediate',
        description: 'OpenShift-specific deployment object with lifecycle hooks, custom triggers, and strategies.',
        topics: ['Rolling', 'Recreate', 'Hooks', 'Triggers'],
      },
      {
        icon: '📡',
        title: 'Routes',
        level: 'beginner',
        description: 'OpenShift Routes expose services externally with HTTP/HTTPS. Supports edge, passthrough, and re-encrypt TLS.',
        topics: ['Edge TLS', 'Passthrough', 'Re-encrypt', 'Wildcards'],
      },
    ],
  },
  {
    title: 'CI/CD & Pipelines',
    icon: '🔁',
    cards: [
      {
        icon: '🔧',
        title: 'OpenShift Pipelines',
        level: 'intermediate',
        description: 'Tekton-based CI/CD framework. Cloud-native, serverless pipelines with Tasks and PipelineRuns.',
        topics: ['Tasks', 'Pipelines', 'PipelineRuns', 'Workspaces'],
      },
      {
        icon: '🐙',
        title: 'OpenShift GitOps',
        level: 'intermediate',
        description: 'Argo CD-based GitOps for declarative application delivery from Git repositories.',
        topics: ['ArgoCD', 'ApplicationSet', 'Sync policy', 'Health checks'],
      },
    ],
  },
  {
    title: 'Security & Operators',
    icon: '🛡️',
    cards: [
      {
        icon: '🔐',
        title: 'Security Context Constraints',
        level: 'advanced',
        description: 'OpenShift SCC controls what Pods can do — similar to Kubernetes PodSecurity policies but more granular.',
        topics: ['anyuid', 'restricted', 'privileged', 'Custom SCC'],
      },
      {
        icon: '🤖',
        title: 'Operators',
        level: 'advanced',
        description: 'Automate application lifecycle with the Operator pattern. OLM manages operator installation and upgrades.',
        topics: ['CRDs', 'OLM', 'OperatorHub', 'Reconciliation'],
      },
      {
        icon: '🌐',
        title: 'Service Mesh',
        level: 'advanced',
        description: 'OpenShift Service Mesh (Istio-based) for traffic management, observability, and mTLS.',
        topics: ['Istio', 'Envoy', 'VirtualService', 'mTLS'],
      },
    ],
  },
];

function Openshift() {
  return (
    <TopicPage
      title="OpenShift"
      subtitle="Enterprise Kubernetes platform by Red Hat — secure, automated, and developer-friendly."
      icon="🔴"
      color="#ee0000"
      sections={sections}
    />
  );
}

export default Openshift;
